import React, { useRef, useState } from 'react';

import { Card } from 'react-bootstrap';

import BookPage from './BookPage';
import CodeArea from './CodeArea';

function Reference() {
  const ref_ = useRef(null);
  const updateIndex = (next) => {
    if (ref_.current === null) return;
    ref_.current.setIndex(next);
  };

  const [info, setInfo] = useState(
    [
      {
        firstIndex:0,
        title:"AEAsAnimationRoot",
        contents:
        [
          {
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>class AEAsAnimationRoot</h2></div>
            
              <hr/>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              <h5>Static methods</h5>
              </div>

              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    <h2>Attach</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public static AEAsAnimationRoot Attach(",
                            indent:0
                          },
                          {
                            body:"Transform parent = null,",
                            indent:1
                          },
                          {
                            body:"string name = \"AEAsAnimationRoot\",",
                            indent:1
                          },
                          {
                            body:"bool asLayout = false,",
                            indent:1
                          },
                          {
                            body:"bool useGlobalColor = false",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Create the animation object. (but doesn't show yet.)
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  parent : transform parent<br/>
                  name : name of the GameObject<br/>
                  asLayout : if true, don't play animation.(Stay in 0 frame)<br/>
                  useGlobalColor : if true, children of thie animation node also recieve color overlay effects<br/>
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>
              
              
              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>Preload</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public static void Preload(",
                            indent:0
                          },
                          {
                            body:"string dataPath,",
                            indent:1
                          },
                          {
                            body:"System.Action OnReady",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Preload the animation data.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  dataPath : path to the animation data json file.<br/>
                  OnReady : excute when the data will be loaded Completely.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>
              

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              <h5>Public methods</h5>
              </div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>Show</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public AEAsAnimationRoot Show(",
                            indent:0
                          },
                          {
                            body:"string dataPath,",
                            indent:1
                          },
                          {
                            body:"System.Action<AEAsAnimationRoot> OnReady = null,",
                            indent:1
                          },
                          {
                            body:"System.Action<AEAsAnimationRoot> OnFailure = null,",
                            indent:1
                          },
                          {
                            body:"bool loop = false",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Show the animation.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  dataPath : path to the animation data json file.<br/>
                  OnReady : excute when the animation loaded Completely.<br/>
                  OnFailure : excute when the error occured.<br/>
                  loop : if true, play the animation with loop.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>ShowAsync</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public IEnumerator ShowAsync(",
                            indent:0
                          },
                          {
                            body:"string dataPath,",
                            indent:1
                          },
                          {
                            body:"System.Action<AEAsAnimationRoot> OnReady = null,",
                            indent:1
                          },
                          {
                            body:"System.Action<AEAsAnimationRoot> OnFailure = null,",
                            indent:1
                          },
                          {
                            body:"bool loop = false",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Show the animation with coroutine.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  dataPath : path to the animation data json file.<br/>
                  OnReady : excute when the animation loaded Completely.<br/>
                  OnFailure : excute when the error occured.<br/>
                  loop : if true, play the animation with loop.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>GoToMarker</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public int GoToMarker(string markerTag, bool loop = false);",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Play the animation from the marker(in After Effects).
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  markerTag : the marker (composition marker) name.<br/>
                  loop : if true, play the animation with loop.<br/>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  returns the flame count between the marker and the next marker.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>GoToStart</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public int GoToStart(bool loop = false, int lastOffset = 0);",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Play the animation from the start point.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  loop : if true, play the animation with loop.<br/>
                  lastOffset : the animation will stop at this offset frames before the end.<br/>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  returns the flame count to the next marker.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>StopAnimation</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public void StopAnimation();",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Stop the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>



              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>Restart</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public void Restart();",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Resume the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>AddSwapImages</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public AEAsAnimationRoot AddSwapImages(",
                            indent:0
                          },
                          {
                            body:"string from,",
                            indent:1
                          },
                          {
                            body:"string to,",
                            indent:1
                          },
                          {
                            body:"bool overrideSize = false,",
                            indent:1
                          },
                          {
                            body:"string directory = \"\"",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Swap the images in the animation before playing.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  from : name of the image swap from.<br/>
                  to : name of the image swap to.<br/>
                  overrideSize : if true, adjust the image size to RectTransform.sizeDelta of the parent.<br/>
                  directory : set the "to file" directory. if empty, image is loaded from in the animation file directory.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>SwapImage</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public void SwapImage(",
                            indent:0
                          },
                          {
                            body:"string from,",
                            indent:1
                          },
                          {
                            body:"string to",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Swap the images in playing.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  from : name of the image swap from.<br/>
                  to : name of the image swap to.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>SetSwapImagesRootDirectory</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public AEAsAnimationRoot SetSwapImagesRootDirectory(",
                            indent:0
                          },
                          {
                            body:"string directory",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Set the "swap to file" directory. if empty, image is loaded from in the animation file directory.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>SetAsLayout</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public AEAsAnimationRoot SetAsLayout();",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Play without the animation(stay in 0 frame).
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>SetGlobalColor</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public AEAsAnimationRoot SetGlobalColor(",
                            indent:0
                          },
                          {
                            body:"Color overlay = default(Color),",
                            indent:1
                          },
                          {
                            body:"Color multiply = default(Color),",
                            indent:1
                          },
                          {
                            body:"float opacity = 1",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Set the override color.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  overlay : additive color.<br/>
                  multiply : multiply color.<br/>
                  opacity : opacity.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>GetLayerGameObjectByName</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public GameObject GetLayerGameObjectByName(",
                            indent:0
                          },
                          {
                            body:"string name,",
                            indent:1
                          },
                          {
                            body:"bool activeOnly = true,",
                            indent:1
                          },
                          {
                            body:"int index = 0",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Provide the access to the layer GameObject.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  name : returns the GameObject of the layer with this name.<br/>
                  activeOnly : if true, ignore deactive layers.<br/>
                  index : if there are same name layers, returns the layer GameObject with this index.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              <h5>Properties</h5>
              </div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>fps</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public float fps;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Frame per secons of the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>totalFrame</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public int totalFrame;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Frame count of the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>markerInfromations</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public string markerInfromations;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Description text of the markers (composition marker) in the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>allMarkers</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public List<string> allMarkers;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Marker names in the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>



              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>allImageFiles</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public List<string> allImageFiles;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Image file names in the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>allLayerNames</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public List<string> allLayerNames;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Layer names in the animation.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>



              </p>
            )  
          }
        ]
      },
      {
        firstIndex:1,
        title:"AEAsAnimationUtils",
        contents:
        [
          {
            index:1,
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>class AEAsAnimationUtils</h2></div>
  
              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              <h5>Static properties</h5>
              </div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>pool</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public static AEAsAnimationPool pool;",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Provides the acces to AEAsAnimationPool as singleton.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              </p>
            )  
          }
        ]
      },
      {
        firstIndex:2,
        title:"AEAsAnimationPool",
        contents:
        [
          {
            index:2,
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>class AEAsAnimationPool</h2></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              <h5>Public methods</h5>
              </div>

              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>Push</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public void Push(",
                            indent:0
                          },
                          {
                            body:"string tag,",
                            indent:1
                          },
                          {
                            body:"AEAsAnimationRoot root",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Store the animation prefab.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  tag : key of the stored prefab.<br/>
                  root : stored prefab.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>Push</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public AEAsAnimationRoot Pop(",
                            indent:0
                          },
                          {
                            body:"string tag,",
                            indent:1
                          },
                          {
                            body:"Transform parent",
                            indent:1
                          },
                          {
                            body:");",
                            indent:0
                          },
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Pick the stored animation prefab out.
                  </div>
                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  tag : key of the stored prefab.<br/>
                  parent : the parent of the prefab picked out.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:40
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                  <h2>Clear</h2>
                  </Card.Title>
                  <Card.Text>
                  <div>
                    <CodeArea
                      lines = {
                        [
                          {
                            body:"public void Clear();",
                            indent:0
                          }
                        ]
                      }
                    />
                  </div>

                  <div
                  style ={{
                    marginTop:20,
                  }}
                  >
                  <h5>Description</h5>
                  </div>

                  <div
                  style ={{
                    marginTop:10
                  }}
                  >
                  Clear the stored animations.
                  </div>

                  </Card.Text>
                </Card.Body>
              </Card></div>


              </p>
            )  
          }
        ]
      }
    ]
    );

  return (
    <div>
      <BookPage
      documentInfos = {info}
      ref = {ref_}
      />
    </div>
  );
}


export default Reference;
